import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';

/**
 * The auth SPA is served by Spring at multiple URL prefixes:
 *   - /ru/register, /kz/forgot-password, ... — Spring forwards them to /auth-spa/index.html
 *   - /auth-spa/* — direct asset access (JS chunks)
 *
 * <base href="/auth-spa/"> in index.html tells the browser where to load the
 * JS / CSS chunks from. But the Angular Router must use APP_BASE_HREF "/" so
 * it matches the FULL path (e.g. /ru/register), not /auth-spa/ru/register.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
  ],
};
